import React, { useState, useEffect } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { useSEO } from "@/lib/seo";
import { toast } from "sonner";

const ReturnRequest = () => {
  useSEO({ title: "Start a Return | NoirbyAmara", description: "Request a return or exchange. We'll email you the return address once approved." });
  const [params] = useSearchParams();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [order, setOrder] = useState("");
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => { window.scrollTo(0, 0); const o = params.get("order"); if (o) setOrder(o); }, [params]);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) { toast("Please enter your email."); return; }
    setBusy(true);
    try {
      await api.post("/returns/request", { name, email, order_number: order, message });
      setDone(true);
    } catch { toast.error("Something went wrong — please email us instead."); }
    setBusy(false);
  };

  const inputCls = "w-full bg-transparent border border-espresso/25 px-4 py-3.5 text-sm outline-none focus:border-espresso";

  return (
    <div className="max-w-xl mx-auto px-6 pt-20 md:pt-28 pb-24" data-testid="return-request-page">
      <p className="overline text-gold mb-4">Returns & Exchanges</p>
      <h1 className="font-serif text-5xl md:text-6xl leading-none mb-8">Start a return.</h1>
      {done ? (
        <div data-testid="return-request-done">
          <p className="text-espresso/75 leading-loose text-lg">Thank you — your request is in. We'll review it and email you the return address and full instructions shortly.</p>
          <Link to="/" className="inline-block mt-8 border border-espresso px-8 py-3.5 text-[0.72rem] tracking-[0.2em] uppercase hover:bg-espresso hover:text-cream transition-colors">Back to home</Link>
        </div>
      ) : (
        <>
          <p className="text-espresso/70 leading-relaxed mb-8">Tell us a little about your return and we'll be in touch with the address and next steps. Pieces should be unworn, with tags attached, in their original condition.</p>
          <form onSubmit={submit} className="space-y-4" data-testid="return-request-form">
            <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Your name" data-testid="return-name" className={inputCls} />
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your email *" data-testid="return-email" className={inputCls} />
            <input value={order} onChange={(e) => setOrder(e.target.value)} placeholder="Order number" data-testid="return-order" className={inputCls} />
            <textarea value={message} onChange={(e) => setMessage(e.target.value)} placeholder="What would you like to return, and why? (optional)" rows={4} data-testid="return-message" className={inputCls} />
            <button type="submit" disabled={busy} data-testid="return-submit"
              className="w-full bg-espresso text-cream px-8 py-4 text-[0.72rem] tracking-[0.22em] uppercase hover:bg-cocoa transition-colors disabled:opacity-50">
              {busy ? "Sending…" : "Send return request"}
            </button>
          </form>
        </>
      )}
    </div>
  );
};

export default ReturnRequest;
